import { useEffect, useState, useRef } from 'react';
import { ModalHeader } from '../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import { actionSearchSemester } from '../../module/body/semester/SemesterStudentUniversityModule';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../component/PopupRef';


const RegSemesterListModal = ({ row, modalRef }) => {

    const popupRef = useRef(null);
    const dispatch = useDispatch();
    const [semesterList, setSemesterList] = useState([]);

      
    useEffect(() => {
        dispatch(
            actionSearchSemester({
                userId : row.userId,
                callback: (result) => {
                    setSemesterList(result?.map(data => data.semesterNm));  
                },
                
            })
        );
    }, []); 

    const handleConfirm = (e) => {
        modalRef.current.close();
    };
    

    return (
        <>
            <ModalHeader title='수강등록학기 목록' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='notice-popup-inner'>
                    <ul className='explain-txt'>
                        {semesterList?.map((value) => (
                            <li key={value}>{value}</li>    
                        ))}
                    </ul>
                        
                </div>
                <div className='modal-btn-wrap'>
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default RegSemesterListModal;